/* eslint-disable react/no-array-index-key */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';

import { reduxForm, FieldArray, Field } from 'redux-form';
import {
  openDialogBindingOffer,
  bindOfferCode,
  resetImportCommands
} from '../actions';

import RenderSelectField from '../../../utils/renderFields/RenderSelectField';
import getOfferCode from '../../../utils/bindings/offerCode';

import validate from './validate';

const OfferMappingContainer = styled.div`
  padding: 10px 40px;
`;

const OfferTitle = styled.span`
  margin-top: 5px;
  font-weight: bold;
`;
/**
 * Champs select permettant de sélectionner les offrres de livraion sympl
 * @param {object} fields              field object
 * @param {Array} unknowDeliveryOffer  Tableau contenant les offres de livraison
 * inconnue présente dans le fichier du client
 */
const RenderOfferCode = ({ fields, unknowDeliveryOffer, accountType }) => (
  <div>
    {fields.map((item, index) => (
      <OfferMappingContainer key={index}>
        <OfferTitle>{unknowDeliveryOffer[index].name}</OfferTitle>
        <Field
          style={{ width: '100%' }}
          name={`${item}.bindingValue`}
          label="Offre de livraison"
          component={RenderSelectField}
          datas={getOfferCode(accountType)}
        />
      </OfferMappingContainer>
    ))}
  </div>
);

RenderOfferCode.propTypes = {
  fields: PropTypes.object.isRequired,
  unknowDeliveryOffer: PropTypes.array.isRequired,
  accountType: PropTypes.string
};

/**
 * Composant permettant de faire la relation entre les offres de livraison
 * présent dans le fichier du client et les offre de livraison sympl.
 * Ce composant est une boite de Dialog qui s'ouvre uniquement dans le cas
 * ou certaine des offrres présente dans le fichier du client sont inconnue
 *
 *
 * @param {Boolean} open                            Défini si la modal "Dialog" est ouverte ou fermé
 * @param {Array} unknowDeliveryOffer               Tableau contenant les offres de livraison
 * @param {Function} handleSubmit                   Sumbit le formulaire voir la methode onSubmit
 * @param {Function} dispatchResetImportCommands    Réinitialise le store import commande
 * @param {Function} dispatchOpenDialogBindingOffer Permet d'ouvrir ou de fermer la Dialog
 * @param {Boolean} loadingImport                   Statut des requêtes
 */
let BindingDialog = ({
  open,
  unknowDeliveryOffer,
  handleSubmit,
  dispatchResetImportCommands,
  dispatchOpenDialogBindingOffer,
  loadingImport,
  accountType
}) => (
  <Dialog open={open} scroll="paper" aria-labelledby="form-dialog-title">
    {loadingImport ? (
      <DialogContent>
        <DialogContentText style={{ marginBottom: 20 }}>
          Analyse de votre fichier en cours
        </DialogContentText>
        <div style={{ textAlign: 'center' }}>
          <CircularProgress />
        </div>
      </DialogContent>
    ) : (
      <form onSubmit={handleSubmit}>
        <DialogTitle>Informations supplémentaires</DialogTitle>
        <DialogContent>
          <DialogContentText style={{ marginBottom: 20 }}>
            Faites correspondre vos méthodes d&lsquo;envoi avec nos offres de
            livraison
          </DialogContentText>
          <FieldArray
            name="unknowDeliveryOffer"
            unknowDeliveryOffer={unknowDeliveryOffer}
            component={RenderOfferCode}
            accountType={accountType}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              dispatchResetImportCommands();
              dispatchOpenDialogBindingOffer(false);
            }}
            color="secondary"
            variant="contained"
          >
            Annuler
          </Button>
          <Button type="submit" color="primary" variant="contained">
            Valider
          </Button>
        </DialogActions>
      </form>
    )}
  </Dialog>
);

BindingDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  dispatchOpenDialogBindingOffer: PropTypes.func.isRequired,
  dispatchResetImportCommands: PropTypes.func.isRequired,
  unknowDeliveryOffer: PropTypes.array.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  loadingImport: PropTypes.bool.isRequired,
  accountType: PropTypes.string
};

const mapStateToProps = state => ({
  accountType: state.init.currentAccountInformations.accountType,
  open: state.importCommands.openDialogBindingOffer,
  unknowDeliveryOffer: state.importCommands.unknowDeliveryOffer,
  commands: state.importCommands.commands,
  loadingImport: state.importCommands.loadingImport,
  initialValues: {
    unknowDeliveryOffer: state.importCommands.unknowDeliveryOffer
  }
});

const mapDispatchToProps = dispatch => ({
  dispatchOpenDialogBindingOffer: data =>
    dispatch(openDialogBindingOffer(data)),
  dispatchResetImportCommands: () => dispatch(resetImportCommands())
});

BindingDialog = reduxForm({
  form: 'bindingOfferForm',
  validate,
  onSubmit: (values, dispatch) => {
    dispatch(bindOfferCode(values));
    dispatch(openDialogBindingOffer(false));
  }
})(BindingDialog);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BindingDialog);
